import InsertNewDataModal from './InsertNewDataModal';

export default InsertNewDataModal;